import styled from "styled-components";

export const StyledDatepicker = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  .react-date-picker__inputGroup__input {
    padding: 0 1px !important;
  }
  .react-date-picker__inputGroup__input--hasLeadingZero {
    padding-left: calc(1px + 0.54em) !important;
  }
  .react-date-picker__wrapper {
    border: none;
   ${({ error }) => error === true ? " border-bottom: 1px solid red;" : " border-bottom: 1px solid rgba(0, 0, 0, 0.42);"};
    cursor: pointer;
    input, span {
      color: inherit;
    }
    button {
      margin: 0;
      padding: 0;
      outline: none;
      svg {
        height: 14px;
        stroke: #757575;
      }
      &:hover, &:focus {
        svg {
          stroke: #277661 !important;
        }
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }
  .react-calendar {
    border: 1px solid rgba(39, 118, 97, 0.5);
    .react-calendar__navigation__arrow,
    .react-calendar__navigation__label,
    .react-calendar__tile {
      &:hover {
        color: #fff;
        background-color: rgba(39, 118, 97, 1);
      }
    }
    .react-calendar__tile--now, .react-calendar__tile--active {
      color: #fff;
    }
    .react-calendar__tile--now {
      background-color: rgba(39, 118, 97, 0.5);
    }
    .react-calendar__tile--active {
      color: #fff;
      background-color: rgba(39, 118, 97, 1);
    }
    .react-calendar__navigation button:enabled:hover, .react-calendar__navigation button:enabled:focus {
      background-color:  rgba(39, 118, 97, 0.5);
    }
    .react-calendar__navigation button[disabled] {
      background-color: inherit;
      opacity: 0.5;
    }
  }
  
  label {
    color: rgba(0, 0, 0, 0.54);
    font-size: 14px;
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
  }
`;